/* eslint-disable-next-line @typescript-eslint/no-explicit-any */
export default function take(obj, props: string[]): any {
  return props.reduce(
    (acc, key) => (obj.hasOwnProperty(key) ? { ...acc, [key]: obj[key] } : acc),
    {},
  );
}
